import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Cell, DataBlock, Grid } from '@fs/zion-ui'
import { PersonLink, TreePersonLink, UserLink } from '../../../app/Links'
import { isNullOrUndefined } from '../../../../util/Utils'
import { printValueOrBooleanReadable } from '../../../../util/StringUtil'
import { findCommonAncestorToUser } from '../../../../services/personService'
import useNotifications from '../../../../hooks/useNotifications'
import { TreeIdCells } from './TreeIdBlock'

export default () => {}

export function OneHundredTenYearsMessageSummary({ messageDetails, queueCachesState, queueCachesActions }) {
  const { t } = useTranslation()
  const [relationship, setRelationship] = useState()
  const { error } = useNotifications()
  const personId = messageDetails?.personId
  const contributorId = messageDetails?.contributorId

  const personSummary = queueCachesState.personsCache[personId]
  const userSummary = queueCachesState.usersCache[contributorId]

  useEffect(() => {
    queueCachesActions.fetchPersonSummary(personId)
    queueCachesActions.fetchUserSummary(contributorId)
    findCommonAncestorToUser(personId, contributorId, true)
      .then((rel) => {
        setRelationship(rel?.relationSummary)
      })
      .catch((err) => {
        switch (err?.response?.status) {
          case 404:
            setRelationship(t('queues.relationship.notFound', 'No common ancestor found'))
            break
          default:
            error(err.message)
        }
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (isNullOrUndefined(personSummary) || isNullOrUndefined(userSummary)) {
    return null
  }

  return (
    <Grid>
      {/* Row */}
      <Cell columns={12}>
        <DataBlock
          heading={t('queues.reservedBy', 'Reserved By')}
          data={
            <UserLink
              userId={contributorId}
              userName={userSummary?.contactName}
              country={userSummary?.country}
              showId
              newTab
            />
          }
        />
      </Cell>

      <TreeIdCells treeId={messageDetails?.treeId} isResearcherTree={messageDetails?.researcherTree} />

      {/* Row */}
      <Cell columns={12}>
        <DataBlock
          heading={t('queues.changedBirthDate', 'Changed Birth Date')}
          data={printValueOrBooleanReadable(messageDetails?.contributorChangedBirthDate)}
        />
      </Cell>

      {/* Row */}
      <Cell columns={12}>
        <DataBlock
          heading={t('personId', 'Person ID')}
          data={
            <>
              <PersonLink personId={personId} personName={personSummary?.summary?.name} showId newTab />
              <TreePersonLink personId={personId} treeIcon newTab />
            </>
          }
        />
      </Cell>

      {/* Row */}
      <Cell columns={12}>
        <DataBlock heading={t('relationship.label', 'Relationship')} data={relationship ?? ''} />
      </Cell>
    </Grid>
  )
}
